export enum Permission {
  MANAGE_USER = 'ROLE_MANAGE_USER',
  CREATE_TRANSACTIONS = 'ROLE_CREATE_TRANSACTIONS',
  MANAGE_PAYMENT_CONTACTS = 'ROLE_MANAGE_PAYMENT_CONTACTS',
  VIEW_ACTIVITY = 'ROLE_VIEW_ACTIVITY',
  RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS = 'ROLE_RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS',
  MANAGE_CUSTOMER = 'ROLE_MANAGE_CUSTOMER',
  CREATE_USD_ACCOUNT = 'ROLE_CREATE_USD_ACCOUNT',
  VIEW_USD_ACCOUNT = 'ROLE_VIEW_USD_ACCOUNT',
  VIEW_BENEFICIARIES = 'ROLE_VIEW_BENEFICIARIES',
  WITHDRAW_INTEGRATOR_EARNINGS = 'ROLE_WITHDRAW_INTEGRATOR_EARNINGS',
  MANAGE_INTEGRATOR_CREDENTIALS = 'ROLE_MANAGE_INTEGRATOR_CREDENTIALS',
}
